import { create } from "zustand";
import { devtools, persist, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { DEFAULT_STATE, SemanticModelStore } from "./defaultState";

export const createSemanticModelStore = () =>
  create<SemanticModelStore>()(
    persist(
      devtools(immer(subscribeWithSelector(() => ({ ...DEFAULT_STATE }))), {
        name: "SemanticModel",
      }),
      {
        name: "semantic-model",
        partialize: (state) => ({ semanticModel: state.semanticModel }),
      },
    ),
  );
